import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToasterMessagesService } from "@sportyano/core/services/toaster-messages/toaster-messages.service";
import { BookingService } from "@sportyano/core/services/booking/booking.service";
import { Observable, forkJoin, of } from "rxjs";
import { environment } from "src/environments/environment";

export interface BookingRequest {
	programs: number[];
	downpayment_amount: number;
	payment_method: 1 | 2 | 3;
	payment_gateway_provider?: string;
	payment_type?: string;
	voucher_id?: number;
	payer_name?: string;
	profile_id?: number;
	program_fees?: any[];
	total_fees_amount?: number;
}

export interface BookingResponse {
	success: boolean;
	message: string;
	data?: {
		payment_url?: string;
	};
}

@Injectable({
	providedIn: "root",
})
export class QuickProgramBookingService {
	private apiUrl = `${environment.baseUrl}academies`;
	private router = inject(Router);
	private toaster = inject(ToasterMessagesService);
	private translateService = inject(TranslateService);
	private _bookingService = inject(BookingService);

	constructor(private http: HttpClient) {}

	/**
	 * Call booking API and handle success/error response
	 */
	callBookingApi(
		bookingPayload: BookingRequest | FormData,
		isFederation: boolean = false,
	): Observable<BookingResponse> {
		const base = isFederation
			? `${environment.baseUrl}federations`
			: this.apiUrl;
		const finalUrl = `${base}/multiple-program-booking`;
		console.log("Final Booking URL:", finalUrl);
		return this.http.post<BookingResponse>(finalUrl, bookingPayload);
	}

	/**
	 * حساب الـ Fees لمجموعة من البرامج
	 */
	fetchFeesForMultiplePrograms(programs: any[]): Observable<any[]> {
		if (!programs || programs.length === 0) return of([]);

		// إنشاء قائمة الطلبات لكل برنامج مختار
		const feeRequests = programs.map((program) => {
			const price = program.total_amount || program.price || 0;
			const academyId = program.academy_id;
			const programId = program.id;
			return this._bookingService.previewFeeCalculation(
				price,
				academyId,
				programId,
			);
		});

		// تنفيذ جميع الطلبات وتجميع النتائج
		return forkJoin(feeRequests);
	}
}
